enum QueryKey {
	IDENTITIES = "IDENTITIES",
	IDENTITY = "IDENTITY",
	CLAIM_HISTORY = "CLAIM_HISTORY",
	BASE_REWARDS_RATE = "BASE_REWARDS_RATE",
	PROFILE_DATA = "PROFILE_DATA",
	SHINKAI_NAMESPACES = "SHINKAI_NAMESPACES",
	DEFAULT_SHINKAI_NAMESPACE = "DEFAULT_SHINKAI_NAMESPACE",
	URQL_CLIENT = "URQL_CLIENT",
	IDENTITY_FROM_CONTRACT = "IDENTITY_FROM_CONTRACT",
	ANALYTICS_EVENT_NAMES = "ANALYTICS_EVENT_NAMES",
	REWARDS_QUESTS = "REWARDS_QUESTS",
	REWARDS_USERS = "REWARDS_USERS",
	MY_QUESTS = "MY_QUESTS",
	POINT_GRANT_SOURCES = "POINT_GRANT_SOURCES",
	POINT_GRANTS_ACTIVITY = "POINT_GRANTS_ACTIVITY",
	POINTS_ACTIVITY = "POINTS_ACTIVITY",
	POINTS_SUMMARY = "POINTS_SUMMARY",
	ACTIVE_QUESTS = "ACTIVE_QUESTS",
	REWARDS_LEADERBOARD = "REWARDS_LEADERBOARD",
	USAGE_STATS = "USAGE_STATS",
}

export default QueryKey;
